import * as React from "react";
import * as Media from "react-media";

import HamburgerIcon from "material-ui/svg-icons/navigation/menu";

interface HeadingProps {
	children: any; // the text to be displayed
	isLabOpen?: boolean; // is the Lab open?
	style?: any;
	hasDrawer?: boolean;

	openDrawer?(): any;
}

const Heading = (props: HeadingProps) => (
	<Media query={{ maxWidth: 768 }}>
		{isMobile => (
			<div
				style={{
					position: "fixed",
					display: "flex",
					flexDirection: "row",
					backgroundColor: "#445A64",
					color: "white",
					padding: "1rem",
					height: "60px",
					width: "100%",
					top: isMobile ? "6rem" : "5rem",
					zIndex: 2,
					paddingLeft: "1.61rem",
					...(props.style || {}),
				}}
			>
				{props.hasDrawer && (
					<HamburgerIcon
						color={isMobile ? "black" : "white"}
						hoverColor="#66D9EF"
						style={{
							cursor: "pointer",
							position: isMobile ? "fixed" : "relative",
							top: isMobile ? "1rem" : 0,
							zIndex: 2,
							margin: isMobile ? 0 : "auto 1rem auto 0",
						}}
						onClick={props.openDrawer}
					/>
				)}

				<h1
					style={{
						alignSelf: "center",
					}}
				>
					{props.children}
				</h1>
			</div>
		)}
	</Media>
);

export default Heading;



// WEBPACK FOOTER //
// ./src/components/Heading.tsx